import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';
import { ICollectionModelProperty } from './collection-model-property.interface';

export interface ICollectionModel extends IMongoWorkspace {
    name: string;
    label: string;
    wordspaceId?: string;
    structure: ICollectionModelProperty[];
}
